module.exports = __webpack_public_path__ + "static/media/Fracture.be96e082.png";